<template>
  <div id="forkids">
    <el-drawer :destroy-on-close="true" :append-to-body="true" title="Ayarlar" :visible.sync="settings"
      :with-header="false" class="aaaa">
      <div class="row p-5">
        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Okuma Metni</label>
          <el-select :popper-append-to-body="false" placeholder="Hazır Metin Seçebilirsiniz" v-model="templateText">
            <el-option v-for="item in templates" :label="item.title" :key="item.id" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Okuma Sesi</label>
          <el-select :popper-append-to-body="false" placeholder="Ses Cinsiyeti Seçin" v-model="gender">
            <el-option v-for="item in ['male', 'female']" :label="item == 'male' ? 'Erkek' : 'Kadın'" :key="item"
              :value="item"></el-option>
          </el-select>
        </div>

        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Okuma</label>
          <el-switch v-model="soundActive" active-text="Açık" :inactive-text="'Kapalı'"></el-switch>
        </div>

        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Aktif Heceyi Renklendir</label>
          <el-switch v-model="activeLetterColorful" active-text="Evet" :inactive-text="'Hayır'"></el-switch>
        </div>
        <div class="col-md-12 mt-4">
          <label for="">Vurgu Rengi</label>
          <el-color-picker color-format="rgb" show-alpha v-model="heceRengi"></el-color-picker>
        </div>
        <div class="col-md-12 mt-4">
          <label for="">Vurgu Tipi</label>
          <el-radio-group v-model="vurgu">
            <el-radio v-for="item in [
                'Yok',
                'Aktif Hecenin Altı Çizik',
                'Aktif Kelimenin Altı Çizik',
                'Aktif Hecenin Altı Noktalı',
                'Aktif Kelimenin Altı Noktalı',
                'İlk Hecenin Altı Çizik',
                'Son Hecenin Altı Çizik',
                'İlk ve Son Hecenin Altı Çizik',
                'İlk Hecenin Altı Noktalı',
                'Son Hecenin Altı Noktalı',
                'İlk ve Son Hecenin Altı Noktalı',
              ]" :label="item" :key="item" :value="item"></el-radio>
          </el-radio-group>
        </div>
        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Hece Okuma Hızı</label>
          <el-slider style="display: flex; flex: 1" v-model="speed" :min="0.5" :max="1.7" :step="0.1"></el-slider>
        </div>

        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Heceler Arası Duraklama Süresi</label>
          <el-slider style="display: flex; flex: 1" v-model="breakTime" :min="250" :max="2000" :step="250"></el-slider>
        </div>

        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Cümleler Arası Duraklama Süresi</label>
          <el-slider style="display: flex; flex: 1" v-model="breakTimeWord" :min="250" :max="2000"
            :step="250"></el-slider>
        </div>

        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Dış Çizgi Vurgusu</label>
          <el-slider style="display: flex; flex: 1" v-model="config.borderOpacity" :min="0" :max="100"
            :step="5"></el-slider>
        </div>
        <div class="col-md-12 mt-4">
          <label for="" class="dark-inverted">Arka Renk Vurgusu</label>
          <el-slider style="display: flex; flex: 1" v-model="config.backgroundOpacity" :min="0" :max="100"
            :step="5"></el-slider>
        </div>
      </div>
    </el-drawer>
    <div id="stage" v-loading="loading" @click="
        pause = true;
        $root.$emit('pause', true);
      ">
      <paused v-if="pause" @click="
          $root.$emit('pause', !pause);
          pause = false;
        "></paused>
      <div class="
          col-md-12
          mt-4
          d-flex
          flex-column
          align-items-center
          justify-content-center
        " v-if="content.text == ''">
        <label for="" style="font-size: 22px; margin-bottom: 20px; color: black">Başlamak İçin Metin Seçin</label>
        <el-select :popper-append-to-body="false" placeholder="Hazır Metin Seçebilirsiniz" v-model="templateText">
          <el-option v-for="(item, index) in templates" :label="item.title" :key="index" :value="item.id"></el-option>
        </el-select>
      </div>
      <a href="javascript:;" @click.stop="
          $root.$emit('pause', !pause);
          pause = !pause;
        " class="pause">
        <i :class="pause == true ? 'el-icon-video-play' : 'el-icon-video-pause'"></i>
      </a>
      <a href="javascript:;" @click.stop="settings = true" class="settings">
        <i class="el-icon-setting"></i>
      </a>
      <div v-for="(row, rowIndex) in content.rows" class="d-flex flex-row flex-wrap ml-5 mr-5">
        <div v-for="(block, blockIndex) in row.blocks" class="d-flex flex-row flex-wrap pl-1 pr-1"
          v-if="currentRow == rowIndex" style="
            border-radius: 10px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: row;
          " :style="{
            border:
              currentCol == blockIndex && vurgu.indexOf('Çiz') == -1
                ? '1px solid rgba(0,0,0,' + config.borderOpacity / 100 + ')'
                : '1px solid transparent',
            backgroundColor:
              currentCol == blockIndex
                ? 'rgba(255,255,255,' + config.backgroundOpacity / 100 + ')'
                : '',
            borderBottom:
              currentCol == blockIndex && vurgu == 'Aktif Kelimenin Altı Çizik'
                ? '1px solid ' + heceRengi
                : currentCol == blockIndex && vurgu.indexOf('Çiz') == -1
                ? '1px solid rgba(0,0,0,' + config.borderOpacity / 100 + ')'
                : '1px solid transparent',
          }">
          <span style="
              position: absolute;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              bottom: 0px;
              color: transparent;
            " :style="{ backgroundColor: heceRengi }" v-if="
              currentCol == blockIndex &&
              vurgu == 'Aktif Kelimenin Altı Noktalı'
            "></span>
          <div v-for="(hece, heceIndex) in block.heceler" :style="{
              color:
                markIndex == hece.index && activeLetterColorful == true
                  ? heceRengi
                  : '',
              borderBottom:
                (markIndex == hece.index &&
                  vurgu == 'Aktif Hecenin Altı Çizik') ||
                (heceIndex == 0 &&
                  (vurgu == 'İlk Hecenin Altı Çizik' ||
                    vurgu == 'İlk ve Son Hecenin Altı Çizik')) ||
                (heceIndex == block.heceler.length - 1 &&
                  (vurgu == 'Son Hecenin Altı Çizik' ||
                    vurgu == 'İlk ve Son Hecenin Altı Çizik'))
                  ? '1px solid ' + heceRengi
                  : '1px solid transparent',
            }" style="
              font-size: 30px;
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;
            ">
            {{ hece.hece }}
            <span style="
                position: absolute;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                bottom: 0px;
                color: transparent;
              " :style="{ backgroundColor: heceRengi }" v-if="
                (markIndex == hece.index &&
                  vurgu == 'Aktif Hecenin Altı Noktalı') ||
                (heceIndex == 0 && vurgu == 'İlk Hecenin Altı Noktalı') ||
                (heceIndex == 0 &&
                  vurgu == 'İlk ve Son Hecenin Altı Noktalı') ||
                (heceIndex == block.heceler.length - 1 &&
                  vurgu == 'Son Hecenin Altı Noktalı') ||
                (heceIndex == block.heceler.length - 1 &&
                  vurgu == 'İlk ve Son Hecenin Altı Noktalı')
              ">{{ hece.hece }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
import * as heceleme from "../components/modules/tekerlemeler/heceleme.json";
export default {
  name: "ForKids",
  data() {
    return {
      content: {
        text: "",
        type: "reverse",
        blocks: [],
        colors: ["purple", "red", "blue", "pink", "green", "orange"],
        totalRow: 0,
        totalCol: 0,
        rows: [],
      },
      fontSize: 25,
      currentRow: 0,
      currentCol: 0,
      sounds: [],
      text: null,
      templates: heceleme,
      templateText: null,
      speed: 0.7,
      loading: false,
      gender: "male",
      sound: null,
      soundActive: true,
      config: {
        colMode: "Normal",
        rowMode: "Normal",
        borderOpacity: 100,
        backgroundOpacity: 100,
      },
      pause: false,
      settings: false,
      markIndex: 0,
      colorful: true,
      repeat: true,
      soundLock: false,
      breakTime: 500,
      breakTimeWord: 500,
      activeLetterColorful: true,
      heceRengi: "rgba(255,0,0,1)",
      vurgu: "Yok",
    };
  },
  async created() { },
  methods: {
    start() {
      if (this.soundActive == true) {
        this.sound.sound.volume = 1;
      } else {
        this.sound.sound.volume = 0;
      }
      this.sound.sound.onplay = () => {
        if (this.soundLock) {
          this.soundLock = false;
          return;
        }
        this.markIndex = 0;

        this.sound.interval = setInterval(() => {
          if (this.pause) return;
          let a = this.sound.timePoints
            .filter(
              (k) => k.timeSeconds * 1000 <= this.sound.sound.currentTime * 1000
            )
            .reverse()[0];

          if (a != undefined && a != null) {
            this.markIndex = parseInt(a.markName);
          } else {
            this.markIndex = 0;
          }

          this.currentRow = this.content.rows.findIndex((row) =>
            row.blocks.some((block) =>
              block.heceler.some((hece) => hece.index == this.markIndex)
            )
          );

          this.currentCol = this.content.rows[this.currentRow].blocks.findIndex(
            (block) => block.heceler.some((k) => k.index == this.markIndex)
          );
        });
      };

      this.sound.sound.onended = () => {
        clearInterval(this.sound.interval);
        if (this.repeat == true) {
          this.sound.sound.play();
        }
      };

      this.sound.sound.play();
    },
    async init() {
      if (this.sound && this.sound.sound) {
        this.sound.sound.onplay = null;
        this.sound.sound.onended = null;
        this.sound.sound.pause();
      }

      this.loading = true;

      clearInterval(this.interval);
      this.interval = null;

      this.sounds = [];

      this.content.rows = [];

      var colIndex = 0;

      var y = [];

      let index2 = 0;

      this.content.text.split(".").map((k, index) => {
        let blocks = [];

        k.split(" ").map((y, index) => {
          let block = {
            text: null,
            heceler: [],
            blockIndex: index,
          };
          (block.text = y.trim()),
            (block.heceler = this.$hecele(y.trim()).map((z, index) => {
              index2 += 1;
              return {
                hece: z,
                index: index2,
                blockIndex: index,
              };
            }));

          blocks.push(block);
        });

        this.content.rows.push({
          text: k.trim(),
          blocks,
        });
      });

      await axios
        .post("module/ttsWordWithSpeedLetter", {
          text: this.content.rows,
          gender: this.gender,
          speed: this.speed,
          breakTime: this.breakTime,
          breakTimeWord: this.breakTimeWord,
          id:
            this.templates.find((x) => x.text == this.content.text).id +
            "_" +
            "0" +
            "_" +
            this.speed +
            "_" +
            this.breakTime +
            "_" +
            this.breakTimeWord,
        })
        .then((res) => {
          var audio = new Audio("data:audio/mp3;base64," + res.data.sound);

          this.sound = {
            sound: audio,
            timePoints: res.data.timepoints,
          };
        });

      clearTimeout(this.timeout);
      this.timeout = null;
      this.timeout = setTimeout(() => {
        this.start();
        this.loading = false;
      }, 750);
    },
    sesli(harf) {
      var sesliharfler = "aîûaeıioöuüAÎÛAEIİOÖUÜ";

      if (sesliharfler.indexOf(harf) > -1) {
        return true;
      } else {
        return false;
      }
    },
    hecele(s) {
      var ss = "";
      var hece = "";
      var boşluk = " ";
      var renkler = ["red", "blue"];
      var x = renkler.length;
      var sayaç = 0;

      var heceler = [];

      for (var i = s.length - 1; i >= 0; i--) {
        hece = s[i] + hece;
        if (
          s[i] == "'" &&
          i > 0 &&
          this.sesli(s[i - 1]) == true &&
          hece.length > 2
        ) {
          ss =
            "<span style='color:" +
            renkler[sayaç % x] +
            "'>" +
            hece +
            "</span>" +
            ss;
          heceler.push(hece);
          hece = "";
          sayaç++;
        } else if (
          s[i] == "'" &&
          i > 1 &&
          this.sesli(s[i - 1]) == false &&
          this.sesli(s[i + 1]) == true
        ) {
          ss =
            "<span style='color:" +
            renkler[sayaç % x] +
            "'>" +
            s[i - 1] +
            hece +
            "</span>" +
            ss;
          heceler.push(hece);
          hece = "";
          sayaç++;
          i--;
        } else {
          if (i == 0) {
            ss =
              "<span style='color:" +
              renkler[sayaç % x] +
              "'>" +
              hece +
              "</span>" +
              ss;
            heceler.push(hece);
            hece = "";
            sayaç++;
          } else {
            if (hece.length == 1) {
              if (
                i > 0 &&
                this.sesli(s[i]) == true &&
                this.sesli(s[i - 1]) == true
              ) {
                ss =
                  "<span style='color:" +
                  renkler[sayaç % x] +
                  "'>" +
                  hece +
                  "</span>" +
                  ss;
                heceler.push(hece);
                hece = "";
                sayaç++;
              }
            }

            if (hece.length == 2) {
              if (
                hece[0] == "r" &&
                s[i - 1] == "t" &&
                this.sesli(s[i - 2]) == false
              ) {
              } else {
                if (i > 1 && s[i - 1] != "'") {
                  if (
                    this.sesli(s[i]) == false &&
                    this.sesli(s[i + 1]) == true
                  ) {
                    ss =
                      "<span style='color:" +
                      renkler[sayaç % x] +
                      "'>" +
                      hece +
                      "</span>" +
                      ss;
                    heceler.push(hece);
                    hece = "";
                    sayaç++;
                  }
                  if (
                    this.sesli(s[i]) == true &&
                    this.sesli(s[i - 1]) == true
                  ) {
                    ss =
                      "<span style='color:" +
                      renkler[sayaç % x] +
                      "'>" +
                      hece +
                      "</span>" +
                      ss;
                    heceler.push(hece);
                    hece = "";
                    sayaç++;
                  }
                } else if (
                  this.sesli(s[i]) == false &&
                  this.sesli(s[i - 1]) == true &&
                  this.sesli(s[i + 1]) == true
                ) {
                  ss =
                    "<span style='color:" +
                    renkler[sayaç % x] +
                    "'>" +
                    hece +
                    "</span>" +
                    ss;
                  heceler.push(hece);
                  hece = "";
                  sayaç++;
                }
              }
            }

            if (hece.length == 3) {
              if (i > 1) {
                if (
                  hece[0] == "r" &&
                  s[i - 1] == "t" &&
                  this.sesli(s[i - 2]) == false
                ) {
                } else {
                  if (this.sesli(s[i]) == false && s[i - 1] != "'") {
                    ss =
                      "<span style='color:" +
                      renkler[sayaç % x] +
                      "'>" +
                      hece +
                      "</span>" +
                      ss;
                    heceler.push(hece);
                    hece = "";
                    sayaç++;
                  }
                }
              } else if (
                this.sesli(s[i]) == false &&
                this.sesli(s[i - 1]) == true
              ) {
                ss =
                  "<span style='color:" +
                  renkler[sayaç % x] +
                  "'>" +
                  hece +
                  "</span>" +
                  ss;
                heceler.push(hece);
                hece = "";
                sayaç++;
              }
            }

            if (hece.length == 4) {
              ss =
                "<span style='color:" +
                renkler[sayaç % x] +
                "'>" +
                hece +
                "</span>" +
                ss;
              heceler.push(hece);
              hece = "";
              sayaç++;
            }
          }
        }
      }

      return heceler.reverse();
    },
  },
  watch: {
    templateText: function () {
      if (this.templateText == null) return;
      this.content.text = this.templates.find(
        (k) => k.id == this.templateText
      ).text;
      this.text = this.content.text = this.templates.find(
        (k) => k.id == this.templateText
      ).text;
      this.templateText = null;
    },
    speed: function () {
      clearTimeout(this.x);
      this.x = setTimeout(() => {
        this.init();
      }, 700);
    },
    breakTime: function () {
      clearTimeout(this.x);
      this.x = setTimeout(() => {
        this.init();
      }, 700);
    },
    breakTimeWord: function () {
      clearTimeout(this.x);
      this.x = setTimeout(() => {
        this.init();
      }, 700);
    },
    text: function () {
      clearTimeout(this.x);
      this.content.text = this.text;
      this.x = setTimeout(() => {
        this.init();
      }, 1200);
    },
    gender: function () {
      clearTimeout(this.x);
      this.x = setTimeout(() => {
        this.init();
      }, 700);
    },
    repeat: function () {
      if (
        this.repeat == true &&
        this.sound != null &&
        this.sound.sound.paused == true
      ) {
        this.sound.sound.play();
      }
    },
    soundActive: function () {
      if (this.sound != null) {
        this.sound.sound.volume = this.soundActive == true ? 1 : 0;
      }
    },
    pause: function () {
      if (this.pause == true && this.sound.sound) {
        this.sound.sound.pause();
      }

      if (this.pause == false && this.sound.sound) {
        this.soundLock = true;
        this.sound.sound.play();
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearTimeout(this.timeout);
    if (this.sound && this.sound.sound) {
      this.sound.sound.onplay = null;
      this.sound.sound.onended = null;
      this.sound.sound.pause();
    }
    this.timeout = null;
    this.interval = null;
  },
};
</script>

<style lang="less">
#forkids {
  background-image: url("/static/images/forkids.jpg");
  width: 100%;
  height: calc(100vh - 53px);
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  #stage {
    width: 800px;
    height: 600px;
    background-color: cornsilk;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    .active-block {
      background: white;
      border-radius: 15px;
    }
  }
}

.el-select-dropdown {
  z-index: 9999999 !important;
}

.aaaa {
  label {
    display: block;
  }

  .el-select {
    width: 100%;
  }

  .el-radio-group {
    font-size: 0;
    width: 100%;
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
    flex-direction: column;
  }
}
</style>

<style lang="less">
.aaaa {
  label {
    display: block;
  }

  .el-select {
    width: 100%;
  }

  .el-radio-group {
    font-size: 0;
    width: 100%;
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
</style>

<style>
.el-color-picker__panel {
  z-index: 999999999999 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Heceleme.vue